<template>
    <div class="pa-4 detail_header" style="font-size: 26px">
        <div>{{ $props.title }}</div>
        <div>จำนวนรวม <b>{{ $props.price }}</b> {{ $props.type }}</div>
    </div>
</template>

<script>
    export default {
        name: "ExpireTitle",
        props: ['title', 'price', 'type'],
    }
</script>

<style scoped>
.detail_header {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 500px) {
  .detail_header {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
    text-align: center;
  }
}
</style>
